import { css, cx } from '@linaria/core'
import type { FC, ReactNode } from 'react'
import { style } from '#styles'

const borderWidth = '1px'
const groupBorderClasses = {
  left: css`
    border-left: solid ${borderWidth} ${style.themeColors.lineDefault};
  `,
  right: css`
    border-right: solid ${borderWidth} ${style.themeColors.lineDefault};
  `,
  both: css`
    border-left: solid ${borderWidth} ${style.themeColors.lineDefault};
    border-right: solid ${borderWidth} ${style.themeColors.lineDefault};
  `,
  none: css``,
} as const

const flexClass = css`
  display: flex;
  height: 100%;
  align-items: center;
`

interface PageHeaderGroupProps {
  children: ReactNode
  border?: 'left' | 'right' | 'both' | 'none'
}

export const PageHeaderGroup: FC<PageHeaderGroupProps> = ({ children, border = 'both' }) => {
  const className = cx(flexClass, groupBorderClasses[border])
  return <div className={className}>{children}</div>
}
